import { render, staticRenderFns } from "./listRecommendedCategory.vue?vue&type=template&id=5c2dbc9a&scoped=true&"
import script from "./listRecommendedCategory.vue?vue&type=script&lang=js&"
export * from "./listRecommendedCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2dbc9a",
  null
  
)

export default component.exports